import { useEffect } from "react";
import { SHOPIFY_URL } from "../lib/config";

export default function StoreRedirect() {
  useEffect(() => {
    window.location.replace(SHOPIFY_URL);
  }, []);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6" data-testid="store-redirect-page">
      <h1 className="font-serif text-4xl text-forest">Taking you to our shop…</h1>
      <p className="text-charcoal/60 mt-4">
        If you're not redirected,{" "}
        <a href={SHOPIFY_URL} className="text-gold underline underline-offset-4" target="_blank" rel="noopener noreferrer">
          click here to visit the shop
        </a>.
      </p>
    </div>
  );
}
